import FormElementReadOnly from "../../../../../global/components/FormElement/FormElementReadOnly/FormElementReadOnly.vue";
import SnapshotIcon from "../../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import translate from "../../../../../global/directives/translate";
import PuxButton from "../../../../../global/components/PuxButton/PuxButton.vue";

// @vue/component
export default {
  name: "TermineingabeTr",
  components: {
    SnapshotIcon,
    FormElementReadOnly,
    PuxButton,
  },
  directives: {
    translate,
  },
  props: {
    termin: {
      type: Object,
      required: true,
    },
    statusReadonly: {
      type: Boolean,
      required: true,
    },
    termineList: {
      type: Array,
      required: true,
    },
    htmlRegelNummer: {
      type: String,
      required: true,
    },
    statusSnapshot: {
      type: Boolean,
      required: false,
    },
    statusSnapshotAdd: {
      type: Boolean,
      required: false,
    },
    statusSnapshotDelete: {
      type: Boolean,
      required: false,
    },
    statusSnapshotChanges: {
      type: Boolean,
      required: false,
    },
    statusSnapshotChangesIcon: {
      type: Boolean,
      required: false,
    },
    snapshotDate: {
      type: String,
      required: false,
      default: undefined,
    },
    openModalCreateOrEdit: {
      type: Function,
      required: false,
      default: () => {},
    },
    confirmDeleteTermin: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  computed: {
    idButtonEdit() {
      return `${ this.htmlRegelNummer }_edit_${ this.termin.pk }`;
    },

    idButtonDelete() {
      return `${ this.htmlRegelNummer }_delete_${ this.termin.pk }`;
    },

    statusShowButtons() {
      return !this.statusReadonly && !this.statusSnapshotDelete && !this.statusSnapshotChanges;
    },

    snapshotIconFirstTdType() {
      if (this.statusSnapshotAdd) {
        return "add";
      }
      if (this.statusSnapshotDelete) {
        return "delete";
      }
      if (this.statusSnapshotChangesIcon) {
        return "changes";
      }
      return "";
    },

    translateVersionTdOptions() {
      return {
        text: this.translateVersionTdText,
        extra: {
          date: this.snapshotDate,
        },
      };
    },

    translateVersionTdText() {
      if (this.statusSnapshotAdd) {
        return "_TXT_AKTUELLE_VERSION_ADDED_COLUMN_{{date}}_";
      }
      if (this.statusSnapshotDelete) {
        return "_TXT_VERSION_REMOVED_COLUMN_{{date}}_";
      }
      if (this.statusSnapshotChanges) {
        return "_TXT_VERSION_MODIFIED_COLUMN_{{date}}_";
      }
      return "_TXT_AKTUELLE_VERSION_";
    },

    classVersion() {
      if (this.statusSnapshotDelete || this.statusSnapshotChanges) {
        return "version-bg";
      }
      return "";
    },

    rowspanFirstTd() {
      return this.statusSnapshotChangesIcon ? 2 : 1;
    },

    statusShowFirstTd() {
      return !(this.statusSnapshotChanges && !this.statusSnapshotChangesIcon);
    },
  },
};
